import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Input, Select } from 'v3/components';
import { currencyOptions } from 'v3/utils/formatter';
import { LoadValueTypeOptions, NegotiationTypeOptions } from '../../utils';
import { StyledCurrencyCol } from './styles';
import { useFreightValues } from '../../context';

export default function HeaderEdit({ disableCurrency, isNational }) {
  const { data, errors, setData, showDailyRate, onChangeCurrency } =
    useFreightValues();

  const currencyType = useMemo(() => {
    return data?.currency?.value === 'BRL'
      ? '(Compra)'
      : data?.currency?.value === 'USD'
        ? '(Venda)'
        : '';
  }, [data?.currency]);

  return (
    <>
      <Row className="my-2">
        <StyledCurrencyCol sm={12} md={showDailyRate ? 4 : 3}>
          <Input
            label="Moeda"
            value={data?.freightExchange}
            onChange={(e) =>
              setData((old) => ({
                ...old,
                freightExchange: e.target.value,
              }))
            }
            masked
            mask={[/\d/, '.', /\d/, /\d/, /\d/, /\d/]}
            error={errors?.freightExchange}
            id="input-moeda"
          />

          {showDailyRate ? (
            <Input label="Moeda dia" value={data?.exchangeDay} id="input-moeda-dia" disabled />
          ) : null}
        </StyledCurrencyCol>
        <Col sm={12} md={showDailyRate ? 2 : 3}>
          <Select
            label={`Câmbio ${currencyType}`}
            disableClear
            value={data?.currency}
            onChange={onChangeCurrency}
            options={currencyOptions}
            isDisabled={disableCurrency}
            id="select-cambio"
          />
        </Col>
        <Col sm={12} md={showDailyRate ? 2 : 3}>
          <Select
            label="Tipo valor carga *"
            value={data?.loadValueType}
            onChange={(value) => {
              setData((old) => ({
                ...old,
                loadValueType: value,
              }));
            }}
            options={LoadValueTypeOptions}
            error={errors['loadValueType.value'] || errors.loadValueType}
            id="select-tipo-valor-carga"
          />
        </Col>
        <Col sm={12} md={showDailyRate ? 4 : 3}>
          <Select
            label="Negociação *"
            value={data?.negotiationType}
            onChange={(value) => {
              setData((old) => ({
                ...old,
                negotiationType: value,
              }));
            }}
            options={NegotiationTypeOptions}
            error={errors['negotiationType.value'] || errors.negotiationType}
            id="select-negociacao-frete"
          />
        </Col>
      </Row>
    </>
  );
}
